import { Box } from '@mui/material';
import { dismissAppBootLoader } from '../../util/homePagePaths';

/**
 * Reserves homepage height while the HomePage chunk loads (prevents footer CLS).
 * Shows a full-screen spinner overlay until HomePage mounts and dismisses the boot loader.
 */
export function HomePageSkeleton() {
    const bootLoaderVisible = typeof document !== 'undefined'
        && document.getElementById('app-boot-loader') !== null;

    return (
        <>
            <Box
                aria-hidden
                sx={{
                    minHeight: { xs: 3400, sm: 3200, md: 3000 },
                    background: `linear-gradient(180deg, #5ECDBF 0%, hsl(222, 52%, 40%) 100%)`,
                    backgroundSize: '100% 560px',
                    backgroundRepeat: 'no-repeat',
                    bgcolor: 'background.default',
                }}
            />
            {!bootLoaderVisible && (
                <Box
                    role="status"
                    aria-live="polite"
                    aria-label="Loading"
                    sx={{
                        position: 'fixed',
                        inset: 0,
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'background.default',
                    }}
                >
                    <div className="app-boot-spinner" />
                </Box>
            )}
        </>
    );
}

/** Call when HomePage has mounted — hides the initial full-screen boot spinner. */
export function dismissHomePageBootLoader(): void {
    dismissAppBootLoader();
}
